<template>
    <div id="centreRight1">
        <div class="bg-color-black">
            <div class="d-flex pt-2 pl-2">
                <span style="color:#5cd9e8">
                  <icon name="chart-line"></icon>
                </span>
                <div class="d-flex">
                    <span class="fs-xl text mx-2">设备日志</span>
                    <dv-decoration-3 style="width:1.25rem;height:.25rem; position:relative;top:-.0375rem;" />
                </div>
            </div>
            <div class="d-flex jc-center body-box">
                <dv-scroll-board :config="config" style="width:5.7rem;height:4rem" />
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    props: {
      config: {
        type: Object
      }
    },
    mounted() {
      // this.draw();
    },
    data() {
      return {
        // config: {
        //   header: ["设备名称", "日志内容"],
        //   data: [
        //     ["组件1", "dev-1"],
        //     ["组件1", "dev-1"],
        //     ["组件1", "dev-1"],
        //     ["组件1", "dev-1"],
        //     ["组件1", "dev-1"],
        //
        //   ],
        //   rowNum: 10, //表格行数
        //   headerHeight: 35,
        //   headerBGC: "#0f1325", //表头
        //   oddRowBGC: "#0f1325", //奇数行
        //   evenRowBGC: "#171c33", //偶数行
        //   // index: true,
        //   // columnWidth: [50],
        //   align: ["center"]
        // }
      };
    },
    components: {},
    methods: {}
  };
</script>

<style lang="scss">
    #centreRight1 {
        padding: 0.2rem;
        height: 4.125rem;
        min-width: 5.75rem;
        border-radius: 0.0625rem;
        .bg-color-black {
            height: 2.8125rem;
            border-radius: 0.125rem;
        }
        .text {
            color: #c3cbde;
        }
        .chart-box {
            margin-top: 0.2rem;
            width: 2.125rem;
            height: 2.125rem;
            .active-ring-name {
                padding-top: 0.125rem;
            }
        }

        .bottom-data {
            .item-box {
                float: right;
                position: relative;
                width: 50%;
                color: #d3d6dd;
                // 金币
                .coin {
                    position: absolute;
                    left: 0.1rem;
                    top: 0.2125rem;
                    font-size: 0.25rem;
                    color: #ffc107;
                }
                .colorYellow {
                    color: yellowgreen;
                }
            }
        }
    }

</style>
